<template>
  <div class="warp">
    <div class="content">
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="chunk">
            <p class="chunk-title">物业信息</p>
            <div class="flex company-info">
              <div class="flex-1 company-info-left" style="display: flex;align-items: center;">
                <div>
                  <img style="height:130px" src="~@/assets/image/company-logo.png" alt="">
                </div>
                <div style="padding:0px 10px">
                  <p class="p-title">{{valueIsNull(board.companyName)}}</p>
                  <p style="margin-top:10px">联系电话：{{valueIsNull(board.contactNo)}}</p>
                </div>
              </div>
              <div class="flex-1">
                <ul class="chunk-ul">
                  <li>
                    <p class="p-title">业主数目</p>
                    <p class="p-value">{{valueIsNull(board.proprietorNum)}}</p>
                  </li>
                  <li>
                    <p class="p-title">场地数目</p>
                    <p class="p-value">{{valueIsNull(board.rentalNum)}}</p>
                  </li>
                  <li>
                    <p class="p-title">当月出租率</p>
                    <p class="p-value">{{valueIsNull(board.rentPercent)}}%</p>
                  </li>
                  <li>
                    <p class="p-title">上月缴费率</p>
                    <p class="p-value">{{valueIsNull(board.lastPaiedPercent)}}%</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="chunk">
            <p class="chunk-title">收支费用</p>
            <div class="flex-flow-column">
              <div class="chunk-list">
                <ul class="chunk-ul-2">
                  <li>
                    <div class="flex item">
                      <div>本月支出</div>
                      <div class="flex-1">{{valueIsNull(board.cost)}}</div>
                    </div>
                  </li>
                  <li>
                    <div class="flex item">
                      <div>本月收入</div>
                      <div class="flex-1">{{valueIsNull(board.income)}}</div>
                    </div>
                  </li>
                  <li>
                    <div class="flex item">
                      <div>本月利润</div>
                      <div class="flex-1">{{valueIsNull(board.profit)}}</div>
                    </div>
                  </li>
                </ul>
              </div>
              <div style="height:150px">
                <div style="width:100%;height:100%" id="chart"></div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="row">
        <div class="chunk flex-1">
          <p class="chunk-title">缴费状态</p>
          <div class="row-2-content">
            <ul class="chunk-ul-2 chunk-ul-2-centenr">
              <li>
                <p class="p-title">本期应缴租户数量</p>
                <p class="p-value">{{valueIsNull(board.shouldPayedNum)}}</p>
              </li>
              <li>
                <p class="p-title">本期实缴租户数量</p>
                <p class="p-value">{{valueIsNull(board.payedNum)}}</p>
              </li>
              <li>
                <p class="p-title">本期待缴租户数量</p>
                <p class="p-value">{{valueIsNull(board.waitPayedNum)}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row ">
        <div class="chunk flex-1">
          <p class="chunk-title">失联信息</p>
          <div class="row-3-content">
            <nk-table :data="tableData" :columns="columns" :showPage="false">
            </nk-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NkTable from '@/components/common/NkTable.vue'
import api from "@common/api/index.js"
export default {
  components: { NkTable },
  data () {
    return {
      tableData: [],
      columns: [
        {
          prop: "proprietorName",
          label: "业主",
          show: true,
        },
        {
          prop: "rentName",
          label: "场地",
          show: true,
        },
        {
          prop: "measureId",
          label: "表计号",
          show: true,
        },
        {
          prop: "measureName",
          label: "表名称",
          show: true,
        },
        {
          prop: "lesseeName",
          label: "租户",
          show: true,
        },
        {
          prop: "lastConnectTime",
          label: "最后一次通信时间",
          show: true,
        }],
      board: {},
      myChart: null
    }
  },
  created () {
    this.getData()
  },
  mounted () {
    this.drawBar([])
  },
  methods: {
    getData () {
      api.tmp.getPropertyInformationOverview().then(res => {
        if (res.success) {
          this.board = res.data
          this.drawBar(res.data.feeList)
          this.tableData = res.data.missList
        }
      })
    },
    drawBar (data) {
      if (!this.myChart) {
        this.myChart = this.$echarts.init(document.getElementById('chart'))
      }
      let xData = []
      let yDataCost = []
      let yDataIncome = []
      for (let i = 0; i < data.length; i++) {
        const element = data[i];
        xData.push(element.date)
        yDataCost.push(element.cost)
        yDataIncome.push(element.income)
      }
      let option = {
        title: {
          show: false
        },
        grid: {
          left: '4%',
          top: '20%',
          right: '4%',
          bottom: '8%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['收入', '支出']
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: xData
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '收入',
            type: 'bar',
            stack: '费用',
            data: yDataIncome
          },
          {
            name: '支出',
            type: 'bar',
            stack: '费用',
            data: yDataCost
          },
        ]
      };

      this.myChart.setOption(option)
    },
    valueIsNull (value) {
      if (value || value === 0) {
        return value
      }
      return '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  color: rgb(102, 102, 102);
  text-align: left;
  .content {
    // background: #fff;
    width: 100%;
    height: 100%;
    .row {
      width: 100%;
      display: flex;
      margin-top: 14px;
      .row-2-content {
        height: 90px;
      }
      .row-3-content {
        height: 250px;
        padding-bottom: 10px;
      }
    }
    .chunk {
      background: #fff;
      border-radius: 4px;
      padding: 0px 10px;
      .chunk-title {
        line-height: 42px;
        height: 42px;
        font-size: 18px;
        font-weight: bold;
      }
      .company-info {
        padding-bottom: 14px;
        height: 186px;
        .company-info-left {
          border-right: 1px solid #eee;
        }
      }
      ul {
        margin: 0px;
        padding: 0px;
        list-style: none;
      }
      .chunk-ul {
        li {
          float: left;
          width: 50%;
          text-align: center;
        }
      }
      .chunk-ul-2 {
        li {
          float: left;
          width: 33.3%;
          padding: 0px 10px;
          box-sizing: border-box;
        }
      }
      .chunk-list {
        height: 50px;
        .item {
          align-items: center;
          font-size: 16px;
          height: 36px;
          line-height: 36px;
          background: #eee;
          padding: 0px 10px;
          div {
            &:last-child {
              text-align: center;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
}
.flex {
  display: flex;
}
.flex-flow-column {
  flex-flow: column;
}
.flex-1 {
  flex: 1;
}
.p-title {
  font-size: 16px;
  font-weight: bold;
}
.p-value {
  line-height: 60px;
  font-size: 22px;
}
.chunk-ul-2-centenr {
  text-align: center;
}
</style>